module.exports = __webpack_public_path__ + "997d164e78c3cdaa6fa6129f6da331f6.png";